import { Post } from '@wellesley/openapi'

const isQuote = (feed?: Post) =>
  feed && !!feed.repostOf && (!!feed.text || feed.uploads.length > 0)

export default isQuote
